export enum SiUnit {
	KILO = 1e3,
	MEGA = 1e6,
	GIGA = 1e9,
	TERA = 1e12,
}

/**
 *
 * @param bytes size in bytes
 * @param unit unit to convert to
 * @returns number represented as specific unit
 */
export const bytesConversion = (bytes: number, unit: SiUnit): number => {
	return bytes / unit;
};

/**
 * converts from bytes to kilo/mega/giga/tera
 *
 * note: uses base 1000, not base 1024
 * @param bytes size in bytes
 * @returns the file size with TB/GB/MB/KB/B appended depending on file size
 */
export const minifyBytes = (bytes: number): string => {
	if (bytes > SiUnit.TERA) {
		return `${(bytes / SiUnit.TERA).toFixed(3)} TB`;
	} else if (bytes > SiUnit.GIGA) {
		return `${(bytes / SiUnit.GIGA).toFixed(3)} GB`;
	} else if (bytes > SiUnit.MEGA) {
		return `${(bytes / SiUnit.MEGA).toFixed(3)} MB`;
	} else if (bytes > SiUnit.KILO) {
		return `${(bytes / SiUnit.KILO).toFixed(3)} KB`;
	} else {
		return `${bytes} B`;
	}
};

/**
 * converts from seconds to hours, minutes and seconds in string format
 * @param totalSeconds
 * @returns hours, minutes and seconds in string format
 */
export const formatSeconds = (totalSeconds: number): string => {
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = Math.floor(totalSeconds % 60);

	if (isNaN(hours)) {
		return 'No results';
	}

	// Pad each unit with a leading zero if it's a single digit
	const hDisplay = String(hours).padStart(2, '0');
	const mDisplay = String(minutes).padStart(2, '0');
	const sDisplay = String(seconds).padStart(2, '0');

	return `${hDisplay}:${mDisplay}:${sDisplay}`;
};
